<div class="cal">
    <div class="cal__head">
        <span class="cal__month">
            {{ monthNames[currentMonth] }} {{ currentYear }}
        </span>
        <div class="cal__nav">
            <button
                type="button"
                class="cal__navbtn"
                [disabled]="!canNavigatePrevious()"
                (click)="previousMonth()"
                aria-label="Previous month">
                <vb-icon name="chevLeft" [size]="16" [strokeWidth]="2"></vb-icon>
            </button>
            <button
                type="button"
                class="cal__navbtn"
                (click)="nextMonth()"
                aria-label="Next month">
                <vb-icon name="chevRight" [size]="16" [strokeWidth]="2"></vb-icon>
            </button>
        </div>
    </div>

    <!-- Day headers -->
    <div class="cal__grid cal__grid--head">
        <span class="cal__dow" *ngFor="let day of daysOfWeek">
            {{ day.label }}
        </span>
    </div>

    <!-- Dates in a 7-column layout -->
    <div class="cal__grid" *ngFor="let week of calendarDays">
        <button
            type="button"
            *ngFor="let day of week"
            class="cal__day"
            [class.cal__day--empty]="day?.day === 0"
            [class.cal__day--selected]="
                isSelected(day?.day ?? 0) && day?.selectable
            "
            [disabled]="!day?.selectable"
            (click)="day?.selectable ? selectDate(day?.day ?? 0) : null">
            <span *ngIf="day?.day !== 0">{{ day?.day }}</span>
        </button>
    </div>
</div>
